import { VehicleWheelImage } from './vehicle_wheel'
export { VehicleWheelImage } from './vehicle_wheel'
export default VehicleWheelImage